import { useAuthStore } from '@store/authStore'

/**
 * Whether the signed-in staff member is an Admin. Moderators can open the users list and a user's page READ-ONLY:
 * every mutating control on those pages checks this and is hidden for them (the Admin API refuses the writes too).
 */
export function useIsAdmin(): boolean {
  const { user } = useAuthStore()
  return !!user?.roles?.includes('Admin')
}
